import { createContext, useContext, useState, useMemo } from 'react';

export const controlViews = ['Selection', 'Filters', 'Weights'];

const defaultMenuValues = {
	isMenuOpen: true,
	setMenuOpen: () => {},
	selectedMenuItem: controlViews[0],
	setSelectedMenuItem: () => {},
};

const MenuContext = createContext(defaultMenuValues);

export const MenuProvider = ({ children }) => {
	// A 400px panel open by default on a 375px phone leaves no chart at all.
	const [isMenuOpen, setMenuOpen] = useState(
		() => window.matchMedia?.('(min-width: 900px)').matches ?? defaultMenuValues.isMenuOpen
	);
	const [selectedMenuItem, setSelectedMenuItem] = useState(defaultMenuValues.selectedMenuItem);

	const value = useMemo(
		() => ({ isMenuOpen, setMenuOpen, selectedMenuItem, setSelectedMenuItem }),
		// Stable identity: the chart's draw effect depends on this object, and a new
		// one every render would rebind and re-transition every shape.
		[isMenuOpen, setMenuOpen, selectedMenuItem, setSelectedMenuItem]
	);

	return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
};

export const useMenuContext = () => useContext(MenuContext);
